import React from 'react'
import { FormattedDate, FormattedTime, FormattedMessage } from 'react-intl'

export const columnsFitment = {
  type: 'Order',
  fields: [
    {
      description: 'Account',
      type: 'Account',
      name: 'account'
    },
    {
      description: 'Owner',
      type: 'User',
      name: 'owner'
    },
    {
      description: 'External ID',
      name: 'external_id'
    },
    {
      description: 'Order UID',
      name: 'order_uid'
    },
    {
      description: 'Status',
      name: 'status_code'
    },
    {
      description: 'Vehicle',
      name: 'vehicle_registration'
    },

    {
      description: 'Fitment Date',
      name: 'completed_date',
      id: 'completed_time',
      Cell: (row) =>
        row.original.completed_date ? (
          <span>
            <FormattedDate value={row.original.completed_date} />
          </span>
        ) : (
          <span />
        )
    },
    {
      description: 'Subscription',
      name: 'subscription'
    },
    {
      description: 'Hardware',
      name: 'hardware_price',
      queryFragment: {
        selections: [{ name: 'details' }]
      },
      Cell: (row) => (row.original.details ? row.original.details.hardware_price : '')
    },
    {
      description: 'Fitter',
      name: 'fitter_name'
    },
    {
      description: 'Package',
      name: 'product_package'
    },
    {
      description: 'Sale Date',
      name: 'sale_date',
      Cell: (row) =>
        row.original.sale_date ? (
          <span>
            <FormattedDate value={row.original.sale_date} />
          </span>
        ) : (
          <span />
        )
    }
  ]
}
